import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets scroll position to the top whenever the route changes.
 * Without this, react-router preserves the previous page's scroll position,
 * so navigating from the bottom of one page to another lands you at the
 * bottom of the new page.
 *
 * Honours `state.preserveScroll` if a callsite intentionally wants to skip
 * the reset (e.g. in-page anchor links).
 */
export default function ScrollToTop() {
  const { pathname, hash, state } = useLocation();

  useEffect(() => {
    if (state && state.preserveScroll) return;
    if (hash) return; // let the browser handle anchor scroll
    // Skip jarring smooth scroll on route changes
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash, state]);

  return null;
}
